// extracted by mini-css-extract-plugin
module.exports = {"tooltip_app_frame_container":"styles_tooltip_app_frame_container__2bccO","tooltip_app_frame":"styles_tooltip_app_frame__NfaLs"};